import { CompanyTypeRequestFormat } from "@/shared/types";
import { CompanyType } from "@/features/types";

export const companyTypeRequestFormatConverter: Partial<
  Record<CompanyType, CompanyTypeRequestFormat>
> = {
  BUYER: "buyers",
  BOUTIQUE: "boutiques",
  AGENCY: "agencies",
};
